export function isObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
export function isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
}
export function isNull(param) {
    return Object.prototype.toString.call(param) === "[object Null]";
}
export function isUndefined(param) {
    return Object.prototype.toString.call(param) === "[object Undefined]";
}
export function isString(param) {
    return typeof param === "string";
}
